import { FC } from "react";

type Props = { children: string };

const SectionTitle: FC<Props> = ({ children }) => {
  return (
    <span className="text-xs font-semibold uppercase tracking-wide text-gray-500">
      {children}
    </span>
  );
};

export default SectionTitle;
